import React from 'react';
import Button from 'components/Button/Button';
import DateSelector from 'components/DateSelector/DateSelector';
import styles from './Filters.module.scss';
import SvgIcon from 'components/Icon/Icon';
import { SvgIcons } from 'common/consts/svgIcons';

interface Props {
  dateFrom: string | null;
  dateTo: string | null;
  labelTo?: string;
  placeholderFrom?: string;
  placeholderTo?: string;
  submitBtnText?: string;
  resetBtnText?: string;
  onChangeDateFrom: (newDate: string) => void;
  onChangeDateTo: (newDate: string) => void;
  onSubmit: () => void;
  onReset: () => void;
  onClose: () => void;
}

const Filters = ({
  dateFrom = null,
  dateTo = null,
  labelTo,
  placeholderFrom,
  placeholderTo,
  submitBtnText,
  resetBtnText,
  onChangeDateFrom,
  onChangeDateTo,
  onSubmit,
  onReset,
  onClose,
}: Props) => {
  return (
    <div className={styles.wrapper}>
      <DateSelector
        date={dateFrom}
        placeholder={placeholderFrom}
        className={styles.datePicker}
        onChange={(date: string) => onChangeDateFrom(date)}
      />
      <div className={styles.dateSeparator}>{labelTo}</div>
      <DateSelector
        date={dateTo}
        placeholder={placeholderTo}
        className={styles.datePicker}
        onChange={(date: string) => onChangeDateTo(date)}
      />
      <div className={styles.ctaWrapper}>
        <Button
          text={submitBtnText}
          onClick={onSubmit}
          className={styles.filterBtn}
        />
        <button className={styles.clearDateBtn} onClick={() => onReset()}>
          {resetBtnText}
        </button>
      </div>
      <button className={styles.closeBtn} onClick={onClose}>
        <SvgIcon
          type={SvgIcons.CLOSE}
          width={16}
          height={16}
          className={styles.closeBtnIcon}
        />
      </button>
    </div>
  );
};

export default Filters;
